import React from "react";

const IconList = ({ items, fill = true, language = "english" }) => {
  return items.map(
    (
      item // Note the use of parentheses instead of curly braces for an implicit return
    ) => (
      <div
        key={item.id}
        style={{
          textAlign: language == "arabic" ? "right" : "left",
          display: "flex",
          flexDirection: language == "arabic" ? "row-reverse" : "row",
          padding: "12px 0px",
          cursor: item.callback ? "pointer" : "default",
        }}
        onClick={item.callback ? item.callback : false}
      >
        <div style={{ width: "15%", margin: "auto", textAlign: "center" }}>
          {item.icon ? item.icon : fill && <div style={{ display: "block", backgroundColor: "#dedede", height: "100%", width: "100%", margin: 5, borderRadius: 8, height: 36, width: 36 }}></div>}
        </div>
        <div style={{ width: item.icon && fill ? "85%" : "100%", padding: "0px 10px" }}>
          {item.title && <span style={{ width: "100%", display: "block", fontWeight: "bold" }}>{item.title}</span>}
          {item.paragraph && <span style={{ width: "100%", display: "block", fontWeight: "normal" }}> {item.paragraph}</span>}
        </div>
      </div>
    )
  );
};

export default IconList;
